// eslint-disable-next-line import/no-absolute-path
import '/../../FE/src/assets/javascripts/libs/slick.js';

export default class SavingsCards {
  constructor(el) {
    this.$el = $(el);
    this.$slider = this.$el.find('.gg-savings-cards__slider');
    this.$infoIcons = this.$el.find('.gg-savings-cards__info-icon');
    this.$pauseBtn = this.$el.find('.gg-savings-cards__pause-btn');
    this.isMobile = window.innerWidth < 768;
    this.isPlaying = true;
    this.clsIcon = 'gg-savings-cards__info-icon';
    // eslint-disable-next-line radix
    this.autoplaySpeed = parseInt(this.$el.data('autoplay-speed')) || 3000;

    // Handle window resize
    $(window).on('resize', () => {
      this.isMobile = window.innerWidth < 768;
    });
  }

  init() {
    this.initSlider();
    this.initPauseBtn();
  }

  initSlider() {
    if (this.$slider.length === 0) {
      return;
    }

    // Initialize Slick slider with standard arrow controls
    this.$slider.slick({
      rows: 0,
      slide: '.gg-savings-cards__card',
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: this.autoplaySpeed,
      arrows: true,
      dots: false,
      swipe: true,
      draggable: true,
      speed: 600,
      appendArrows: this.$el.find('.slick-controls'),
      prevArrow: `
        <button type="button" class="slick-prev gg-slick-arrow gg-slick-arrow-green">
          <span class="icomoon icon-arrow-left"></span>
        </button>
      `,
      nextArrow: `
        <button type="button" class="slick-next gg-slick-arrow gg-slick-arrow-green">
          <span class="icomoon icon-arrow-right"></span>
        </button>
      `,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
    this.setActiveSlide();
    this.$slider.on('beforeChange', () => { this.setActiveSlide(); });
    this.clickTooltip();
  }

  setActiveSlide() {
    this.$slider.find('.active').removeClass('active');
    setTimeout(() => {
      const $slickActive = this.$slider.find('.slick-active');
      $slickActive.each((_index, element) => {
        const dataIndex = $(element).data('index');
        this.$slider.find(`[data-index="${dataIndex}"]`).addClass('active');
      });
    }, 0);
  }

  clickTooltip() {
    this.$slider.find('.gg-savings-cards__card-link').on('click', (e) => {
      if ($(e.target).closest(`.${this.clsIcon}`).length > 0 || $(e.target).is(`.${this.clsIcon}`)) {
        e.stopPropagation();
        e.preventDefault();
      }
    });
  }

  initPauseBtn() {
    if (this.$pauseBtn.length === 0) {
      return;
    }

    this.$pauseBtn.on('click', () => {
      this.isPlaying = !this.isPlaying;

      if (this.isPlaying) {
        this.$slider.slick('slickPlay');
        this.$pauseBtn.html(`
          <span class="icomoon icon-pause"></span>
        `);
        this.$pauseBtn.attr('aria-label', 'Pause slider');
      } else {
        this.$slider.slick('slickPause');
        this.$pauseBtn.html(`
          <span class="icomoon icon-play"></span>
        `);
        this.$pauseBtn.attr('aria-label', 'Play slider');
      }
    });
  }
}
$(document).ready(() => {
  $('.gg-savings-cards').each((_index, el) => {
    new SavingsCards(el).init();
  });
});
